import { reactive } from 'vue';

export const viewerSheetState = reactive({
    isOpen: false,
    currentModel: '',
    currentId: '' as string | number,

    openViewerSheet(model: string, id: string | number) {
        viewerSheetState.currentModel = model;
        viewerSheetState.currentId = id;
        viewerSheetState.isOpen = true;
    },

    closeViewerSheet() {
        viewerSheetState.isOpen = false;
    },
});

export function useViewerSheet() {
    return viewerSheetState;
}
